<template>
  <div>
    <el-form ref="form" :model="form" :rules="rules" label-position="top" size="small">
      <el-row :gutter="10">
        <el-col :xs="24" :sm="12" :md="12" :lg="8" :xl="8">
          <el-form-item label="选择门店" prop="storeCode">
            <el-select v-model="form.storeCode" placeholder="请选择门店" :filterable="true" @change="storeChange">
              <el-option
                v-for="item in storeOptions"
                :key="item.storeCode"
                :label="item.storeName"
                :value="item.storeCode">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :xs="24" :sm="12" :md="12" :lg="8" :xl="8">
          <el-form-item label="手机号码" prop="phone">
            <el-input v-model="form.phone" prefix-icon="el-icon-mobile-phone"></el-input>
          </el-form-item>
        </el-col>
        <el-col :xs="24" :sm="12" :md="12" :lg="8" :xl="8">
          <el-form-item label="投诉区域" prop="region">
            <el-select v-model="form.region" placeholder="请选择" :filterable="true">
              <el-option
                v-for="item in regionOptions"
                :key="item.regionCode"
                :label="item.regionName"
                :value="item.regionName">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
          <el-form-item label="投诉事项" prop="matters">
            <el-input type="textarea" v-model="form.matters" :rows="3" :maxlength="300"
                      show-word-limit></el-input>
          </el-form-item>
        </el-col>
        <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
          <el-form-item label="上传购物凭证/投诉图片" prop="image">
            <el-upload action="" :on-change="handleChange"
                       accept="image/*"
                       :on-preview="handlePictureCardPreview" :on-remove="handleRemove" multiple
                       list-type="picture-card" :auto-upload="false" :limit="5">
              <i class="el-icon-plus"></i>
            </el-upload>
            <div style="font-size: 12px;color: #666;">
              只能上传图片文件,且不超过 5MB,最多上传 5 张图片
            </div>
            <el-dialog :visible.sync="dialogVisible">
              <img height="56px" width="56px" :src="dialogImageUrl" alt="">
            </el-dialog>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <el-button :loading="isSubmitting" type="danger" @click="onSubmit" style="text-align: center;border-radius: 5px;width: 100%; margin-top: 10px">
      <span v-if="isSubmitting">提交中</span>
      <span v-else>提交</span>
    </el-button>
  </div>


</template>

<script>
import { appendComplaintFormFields } from '../utils/complaintSubmit'

export default {
  name: 'App',
  props: {
    deptcode: {type: String},
    mpSession: {type: String, default: ''},
  },
  data() {
    const image = (rule, value, callback) => {
      if (this.tempFiles.length === 0) {
        callback(new Error('请上传相关图片'))
      } else {
        callback()
      }
    }
    return {
      storeOptions: [],
      regionOptions: [],
      form: {},
      rules: {
        phone: [
          {required: true, message: '请输入手机号码', trigger: 'blur'},
          {
            pattern: /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/,
            message: '请输入正确的号码格式',
            trigger: 'blur'
          }
        ],
        storeCode: [
          {required: true, message: '请输入投诉门店', trigger: 'blur'}
        ],
        region: [
          {required: true, message: '请输入投诉区域', trigger: 'blur'}
        ],
        matters: [
          {required: true, message: '请输入投诉事项', trigger: 'blur'}
        ],
        image: [{required: true, validator: image, trigger: 'change'}],
      },
      dialogImageUrl: '',//窗口预览图片路径
      dialogVisible: false,//预览窗口是否打开
      tempFiles: [], // 用于临时存储文件，以便在提交时一起发送
      isSubmitting: false
    }
  },
  created() {
    this.getComplaintStoreList()
    this.getComplaintRegionList()
    if (this.deptcode) {
      this.form.storeCode = this.deptcode
    }
  },
  methods: {
    // 获取门店列表
    async getComplaintStoreList() {
      const res = await this.$http.get('/complaintStore')
      if (String(res.code) === '1') {
        this.storeOptions = res.data
      } else {
        return this.$message.error("获取门店数据失败")
      }
    },
    // 获取投诉区域列表
    async getComplaintRegionList() {
      const res = await this.$http.get('/complaintRegion')
      if (String(res.code) === '1') {
        this.regionOptions = res.data
      } else {
        return this.$message.error("获取区域数据失败")
      }
    },
    storeChange(value) {
      // 1、使用循环方式获取storeName
      this.storeOptions.forEach(item => {
        if (item.storeCode === value) {
          this.form.storeName = item.storeName;
        }
      })
      // // 2、使用数组的find方法获取storeName
      // // 数组实例的find方法用于找出第一个符合条件的数组成员
      // const store =  this.storeOptions.find(item => item.storeCode === value);
      // this.form.storeName = store.storeName;
    },
    onSubmit() {
      this.storeOptions.forEach(item => {
        if (item.storeCode === this.form.storeCode) {
          this.form.storeName = item.storeName;
        }
      })
      this.$refs.form.validate(async valid => {
        if (valid) {
          this.isSubmitting = true
          // 创建一个 FormData 对象来存储要发送的数据
          const formData = new FormData();
          // 添加图片文件
          if (this.tempFiles.length > 0) {
            this.tempFiles.forEach((file, index) => {
              formData.append('images', file.raw);
            });
          }
          appendComplaintFormFields(formData, this.form, '1', this.mpSession, this.$route && this.$route.query)
          const res = await this.$http.post('/complaint', formData)
          if (String(res.code) === '1') {
            this.isSubmitting = false
            // 刷新页面
            this.$message.success('感谢您的提交 会在24小时内回复处理')
            setTimeout(() => {
              location.reload()
            }, 1000)
          } else {
            this.isSubmitting = false
            return this.$message.error('提交失败，请稍后再试');
          }
        }
      })
    },
    handleRemove(file, fileList) {
      const index = this.tempFiles.indexOf(file);
      if (index > -1) {
        this.tempFiles.splice(index, 1);
      }
    },
    handleChange(file, fileList) {
      const isImage = file.raw.type.startsWith('image/');
      const index = fileList.indexOf(file);
      const isLt2M = file.raw.size / 1024 / 1024  < 5;
      if (!isImage) {
        return this.$message.error('上传文件只能是图片!');
      }
      if (!isLt2M) {
        fileList.splice(index, 1);
        return this.$message.error('上传图片大小不能超过 5MB!');
      }
      this.tempFiles = fileList
    },
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
  }
}
</script>

<style>

.el-form-item--mini.el-form-item, .el-form-item--small.el-form-item {
  margin-bottom: 4px;
}

.el-form--label-top .el-form-item__label {
  padding: 0;
}


.el-select {
  width: 100%;
}


.el-upload--picture-card {
  width: 56px;
  height: 56px;
  line-height: 58px;
}

.el-upload--picture-card i {
  font-size: 20px;
  color: #8c939d;
}

.el-upload-list--picture-card .el-upload-list__item {
  width: 56px;
  height: 56px;
}

.el-upload-list--picture-card .el-upload-list__item-actions span + span {
  margin-left: 10px;
}


</style>



// WEBPACK FOOTER //
// src/components/ComplaintForm.vue